import styled from 'styled-components';

import ThemeV2 from '../../../componentsV2/theme';

export const Button = styled.div<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${({ isSelected }) =>
    isSelected ? ThemeV2.palette.geekBlue2 : ThemeV2.palette.gray1};
  color: ${({ isSelected }) =>
    isSelected ? ThemeV2.palette.geekBlue6 : ThemeV2.palette.gray9};
  font-size: 20px;
  line-height: 28px;
  font-family: ${ThemeV2.typography.adminFontFamily};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transform: all 0.5s ease-in-out;
  &:hover {
    color: ${ThemeV2.palette.geekBlue6};
    background-color: ${({ isSelected }) =>
      isSelected ? ThemeV2.palette.geekBlue2 : ThemeV2.palette.geekBlue1};
  }
`;

export const SvgWrapper = styled.span`
  margin-right: 8px;
`;
